/*
=========================================================
 * Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { useTranslation } from "react-i18next";

// Material Kit 2 React examples
// import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Images
// import team1 from "assets/images/team-5.jpg";
// import team2 from "assets/images/bruce-mars.jpg";
// import team3 from "assets/images/ivana-squares.jpg";
// import team4 from "assets/images/ivana-square.jpg";

function Video() {
  const { t } = useTranslation();
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              {t("services.videoSection.title")}
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              {t("services.videoSection.description")}
            </MKTypography>
          </Grid>
        </Grid>
        {/* First row: 2 videos */}
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={6}>
            <MKTypography variant="h6" color="white" textAlign="center" mb={1}>
              {t("services.videoSection.realState.title")}
            </MKTypography>
            <MKBox sx={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
              <MKBox
                component="iframe"
                src={t("services.videoSection.realState.url")}
                title="Team Video 1"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                }}
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={6}>
            <MKTypography variant="h6" color="white" textAlign="center" mb={1}>
              {t("services.videoSection.Bankruptcies.title")}
            </MKTypography>
            <MKBox sx={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
              <MKBox
                component="iframe"
                src={t("services.videoSection.Bankruptcies.url")}
                title="Team Video 2"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                }}
              />
            </MKBox>
          </Grid>
        </Grid>
        {/* Second row: 1 centered video */}
        <Grid container spacing={3} justifyContent="center" sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <MKTypography variant="h6" color="white" textAlign="center" mb={1}>
              {t("services.videoSection.LivingTrust.title")}
            </MKTypography>
            <MKBox sx={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
              <MKBox
                component="iframe"
                src={t("services.videoSection.LivingTrust.url")}
                title="Team Video 3"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                }}
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Video;
